module.exports = __webpack_public_path__ + "img/learner-quiz-Moose-Q5.672693cb.png";